module.exports = __webpack_public_path__ + "static/media/real_estate.4fc87495.png";